<template>
  <div class="animated fadeIn encuesta-usuario">
    <b-row>
      <b-col cols="12">
        <b-card header="Encuesta de Usuario">
          <b-form>
            <b-form-group
              label="Fecha Encuesta"
              label-for="fechaEncuesta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaEncuesta" 
                :value="fechaEncuesta | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tipo Encuesta"
              label-for="encuestaUsuarioTipo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="encuestaUsuarioTipo"
                :value="encuestaUsuarioTipo"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Usuario"
              label-for="usuarioReferido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="usuarioReferido"
                :value="usuarioReferido"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Referencia"
              label-for="referencia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="referencia"
                :value="referencia"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Calificación"
              label-for="calificacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="calificacion"
                :value="calificacion | numero(2, true)"
                readonly
                type="text"/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Resultados de la Encuesta" class="mt-3">
          <div v-for="(item, index) in items" :key="index">
            <template v-if="item.tipoConsulta == 1">
              <app-calificacion
                :itemId="item.id"
                :consulta="item.consulta"
                :calificacion="item.calificacion"
                :readOnly="true">
              </app-calificacion>
            </template>
            <template v-if="item.tipoConsulta == 2">
              <app-item-aprobado
                :itemId="item.id"
                :consulta="item.consulta"
                :itemSelected="item.aprobado"
                :readOnly="true">
              </app-item-aprobado>
            </template>
          </div>
        </b-card>

        <b-card header="Observaciones">
          <b-form>
            <b-form-group>
              <b-form-textarea
                id="observaciones"
                :value="observaciones" 
                rows="5"
                max-rows="5"
                readonly>
              </b-form-textarea>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Calificacion from  './Calificacion.vue';
import ItemAprobado from  './ItemAprobado.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'encuestaUsuarioDatos/getField',
  mutationType: 'encuestaUsuarioDatos/updateField',
});

export default {
  name: 'EncuestaUsuarioDatos',
  components: {
    appCalificacion: Calificacion,
    appItemAprobado: ItemAprobado,
    Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'fechaEncuesta',
      'encuestaUsuarioTipo',
      'usuarioReferido',
      'referencia',
      'items',
      'calificacion',
      'observaciones',
    ]),
  },  
  created() {
    let encuestaUsuarioId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        encuestaUsuarioId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('encuestaUsuarioDatos/getEncuestaUsuario', encuestaUsuarioId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'EncuestasUsuarios' });
    },
  },
}
</script>
